var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarPlusDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H21V19C21 19.2652 20.8891 19.5196 20.6917 19.7071C20.4943 19.8946 20.2265 20 19.9474 20H2.05263C1.77346 20 1.50572 19.8946 1.30831 19.7071C1.1109 19.5196 1 19.2652 1 19V8Z",
    stroke: "#99D4D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.90909C1 3.66798 1.1109 3.43675 1.30831 3.26627C1.50572 3.09578 1.77346 3 2.05263 3H19.9474C20.2265 3 20.4943 3.09578 20.6917 3.26627C20.8891 3.43675 21 3.66798 21 3.90909V8H1V3.90909Z",
    stroke: "#99D4D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78955 1V5.21053",
    stroke: "#99D4D0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2104 1V5.21053",
    stroke: "#99D4D0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11V17",
    stroke: "#99D4D0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L14 14",
    stroke: "#99D4D0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPlusDisabled);
export default __webpack_public_path__ + "static/media/calendar-plus-disabled.8f64363c003c76b0e6e06552477bcf6d.svg";
export { ForwardRef as ReactComponent };